import { CloseSnackbarNotificationReducer } from './types';

export const closeSnackbarNotificationReducer: CloseSnackbarNotificationReducer =
  (state, action) => {
    const { key, dismissAll } = action.payload;

    return {
      ...state,
      notifications: state.notifications.map((notification) =>
        dismissAll || notification.key === key
          ? { ...notification, dismissed: true }
          : { ...notification }
      ),
    };
  };
